var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.16392 52.8361C3.39776 50.0699 1.84375 46.3182 1.84375 42.4062C1.84375 38.4943 3.39776 34.7426 6.16392 31.9764C8.93009 29.2103 12.6818 27.6562 16.5938 27.6562C20.5057 27.6562 24.2574 29.2103 27.0236 31.9764C29.7897 34.7426 31.3438 38.4943 31.3438 42.4062C31.3438 46.3182 29.7897 50.0699 27.0236 52.8361C24.2574 55.6022 20.5057 57.1562 16.5938 57.1562C12.6818 57.1562 8.93009 55.6022 6.16392 52.8361Z",
    stroke: "#D38B2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21875 42.4058C9.21875 40.4498 9.99576 38.574 11.3788 37.1909C12.7619 35.8078 14.6378 35.0308 16.5938 35.0308M35.0313 20.2808C35.0313 23.2154 36.197 26.0298 38.2721 28.1049C40.3472 30.18 43.1616 31.3457 46.0962 31.3457C49.0308 31.3457 51.8452 30.18 53.9203 28.1049C55.9954 26.0298 57.1612 23.2154 57.1612 20.2808C57.1612 17.3462 55.9954 14.5318 53.9203 12.4567C51.8452 10.3816 49.0308 9.21582 46.0962 9.21582C43.1616 9.21582 40.3472 10.3816 38.2721 12.4567C36.197 14.5318 35.0313 17.3462 35.0313 20.2808Z",
    stroke: "#D38B2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4062 20.2812C42.4062 19.3033 42.7948 18.3653 43.4863 17.6738C44.1778 16.9823 45.1158 16.5937 46.0937 16.5937M29.4041 35.0902L37.851 27.6562M35.9851 15.7825L20.033 9.00733M9.21875 7.375C9.21875 8.84198 9.80151 10.2489 10.8388 11.2862C11.8761 12.3235 13.283 12.9062 14.75 12.9062C16.217 12.9062 17.6239 12.3235 18.6612 11.2862C19.6985 10.2489 20.2812 8.84198 20.2812 7.375C20.2812 5.90802 19.6985 4.50113 18.6612 3.46382C17.6239 2.4265 16.217 1.84375 14.75 1.84375C13.283 1.84375 11.8761 2.4265 10.8388 3.46382C9.80151 4.50113 9.21875 5.90802 9.21875 7.375Z",
    stroke: "#D38B2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChain);
export default __webpack_public_path__ + "static/media/chain.d03dc26e021e6ec437759efe636308a8.svg";
export { ForwardRef as ReactComponent };